import React, { useEffect } from 'react';
import AboutPage from './components/AboutPage';
import AlgoFoxLandingNew from './components/AlgoFoxLandingNew';
import ErrorBoundary from './components/ErrorBoundary';
import PrivacyPolicy from './components/PrivacyPolicy';

const publicRoutes = new Set(['/', '/about', '/privacy']);

const App: React.FC = () => {
  const path = window.location.pathname;
  const isAboutPage = path === '/about';
  const isPrivacyPage = path === '/privacy';

  useEffect(() => {
    if (!publicRoutes.has(window.location.pathname)) {
      window.history.replaceState({}, '', `/${window.location.hash}`);
    }
  }, []);

  return (
    <ErrorBoundary>
      {isAboutPage ? <AboutPage /> : isPrivacyPage ? <PrivacyPolicy /> : <AlgoFoxLandingNew />}
    </ErrorBoundary>
  );
};

export default App;
